export function configureHttpInterceptors({
  http,
  store,
  router,
  cookies,
  showToast,
}) {
  let activeRequests = 0;

  const startLoading = () => {
    activeRequests += 1;
    if (activeRequests === 1) {
      store.dispatch("setLoading", true);
    }
  };

  const stopLoading = () => {
    if (activeRequests > 0) {
      activeRequests -= 1;
    }
    if (activeRequests === 0) {
      store.dispatch("setLoading", false);
    }
  };

  http.interceptors.request.use(
    (config) => {
      startLoading();
      return config;
    },
    (error) => {
      stopLoading();
      return Promise.reject(error);
    },
  );

  http.interceptors.response.use(
    (response) => {
      stopLoading();
      return response;
    },
    (error) => {
      stopLoading();

      if (error.config?.url?.includes("/login")) {
        return Promise.reject(error);
      }

      const { status, data = {} } = error.response || {};

      if (status === 401) {
        store.dispatch("clearUser");
        cookies.remove("auth_token", { path: "/" });
        cookies.remove("user_type", { path: "/" });
        router.push("/");
        showToast({
          severity: "error",
          summary: "Błąd autoryzacji",
          detail: "Twoja sesja wygasła. Zaloguj się ponownie.",
          life: 5000,
        });
      } else if (status === 403) {
        showToast({
          severity: "warn",
          summary: "Brak dostępu",
          detail:
            data.message || "Nie masz uprawnień do wykonania tej operacji.",
          life: 5000,
        });
      } else if (status === 422 && data.errors) {
        Object.entries(data.errors).forEach(([key, messages]) => {
          messages.forEach((message) => {
            showToast({
              severity: "error",
              summary: "Błąd walidacji",
              detail: `${key}: ${message}`,
              life: 5000,
            });
          });
        });
      } else if (
        status === 500 &&
        data.message ===
          "Nie można połączyć się z bazą danych. Spróbuj ponownie później."
      ) {
        showToast({
          severity: "error",
          summary: "Błąd serwera",
          detail:
            "Nie można połączyć się z bazą danych. Spróbuj ponownie później.",
          life: 5000,
        });
      } else if (error.request && !error.response) {
        showToast({
          severity: "error",
          summary: "Błąd sieci",
          detail:
            "Nie można połączyć się z serwerem. Sprawdź połączenie internetowe lub spróbuj ponownie później.",
          life: 5000,
        });
      } else if (!error.response) {
        showToast({
          severity: "error",
          summary: "Błąd",
          detail: "Wystąpił nieoczekiwany błąd.",
          life: 5000,
        });
      }

      return Promise.reject(error);
    },
  );
}

